module.exports = __webpack_public_path__ + "static/media/October_2026_3.fcae88e1.webp";